
import { OptimizedImage } from '@/components/OptimizedImage';

interface ImageWithTextBlockProps {
  content: {
    imageUrl: string;
    imageAltText: string;
    textSide: string;
    imagePosition: 'left' | 'right';
  };
}

export const ImageWithTextBlock = ({ content }: ImageWithTextBlockProps) => {
  const { imageUrl, imageAltText, textSide, imagePosition } = content;

  if (!imageUrl && !textSide) return null;

  return (
    <section className="py-16 px-6">
      <div className="max-w-6xl mx-auto">
        <div className={`grid md:grid-cols-2 gap-12 items-center ${
          imagePosition === 'right' ? 'md:grid-flow-col-dense' : ''
        }`}>
          {imageUrl && (
            <div className={imagePosition === 'right' ? 'md:col-start-2' : ''}>
              <OptimizedImage
                src={imageUrl}
                alt={imageAltText || ''}
                width={600}
                height={400}
                className="w-full h-auto rounded-lg shadow-lg"
                optimization={{ quality: 85, format: 'webp' }}
              />
            </div>
          )}
          {textSide && (
            <div className={imagePosition === 'right' ? 'md:col-start-1' : ''}>
              <div 
                className="prose prose-lg max-w-none"
                dangerouslySetInnerHTML={{ __html: textSide }}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
